'use client'

import { Phone } from 'lucide-react'
import { useEffect, useState } from 'react'

/**
 * Appel d'urgence flottant. Apparaît après le héros, où le numéro est
 * déjà visible en grand. C'est le seul aplat de signal permanent du
 * site : pas d'animation d'appel d'attention (ping, wiggle), qui
 * fatiguait la page et ignorait prefers-reduced-motion.
 */
export default function FloatingSOS() {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const toggle = () => setIsVisible(window.scrollY > 400)
    toggle()
    window.addEventListener('scroll', toggle, { passive: true })
    return () => window.removeEventListener('scroll', toggle)
  }, [])

  return (
    <a
      href="tel:+33620111014"
      aria-label="Appeler l'assistance urgence 7j/7 au 06 20 11 10 14"
      aria-hidden={!isVisible}
      tabIndex={isVisible ? undefined : -1}
      className={`group fixed bottom-5 right-5 z-40 inline-flex items-center gap-3 rounded-[3px] bg-signal px-4 py-3.5 text-white shadow-[0_10px_40px_-8px_rgba(240,83,28,0.6)] transition-all duration-300 tablet:bottom-8 tablet:right-8 hover:bg-signal-deep ${
        isVisible
          ? 'translate-y-0 opacity-100'
          : 'pointer-events-none translate-y-3 opacity-0'
      }`}
    >
      <Phone className="size-4 shrink-0" strokeWidth={2} aria-hidden="true" />
      <span className="hidden font-mono text-[0.6875rem] font-medium uppercase tracking-[0.16em] tablet:inline">
        SOS Urgence 7j/7
      </span>
    </a>
  )
}
